import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axios";

/**
 * Async thunk to fetch medications from the database
 */
export const fetchMedications = createAsyncThunk(
  "medicationsDatabase/fetchMedications",
  async ({ page = 1, limit = 20 } = {}, { rejectWithValue }) => {
    try {
      const response = await axios.get("/medications/database", {
        params: { page, limit },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch medications database"
      );
    }
  }
);

/**
 * Async thunk to search medications in the database
 */
export const searchMedications = createAsyncThunk(
  "medicationsDatabase/searchMedications",
  async (
    { q, dci, laboratoire, classeTherapeutique, page = 1, limit = 20 } = {},
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.get("/medications/search", {
        params: { q, dci, laboratoire, classeTherapeutique, page, limit },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to search medications"
      );
    }
  }
);

/**
 * Alias for getMedicationById - used by useMedicationsDatabase
 */
export const fetchMedicationById = createAsyncThunk(
  "medicationsDatabase/fetchMedicationById",
  async ({ medicationId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/medications/database/${medicationId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch medication details"
      );
    }
  }
);

/**
 * Alias for getMedicationStats - used by useMedicationsDatabase
 */
export const fetchMedicationsStats = createAsyncThunk(
  "medicationsDatabase/fetchMedicationsStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/medications/stats");
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch medication stats"
      );
    }
  }
);

/**
 * Get medication by ID
 */
export const getMedicationById = fetchMedicationById;

/**
 * Get medication stats
 */
export const getMedicationStats = fetchMedicationsStats;
